var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCliente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5033 12.8391C16.7604 13.3758 17.8899 14.1605 18.8206 15.1437C18.9617 15.2957 19.0419 15.4922 19.0465 15.6971V19.0856C19.0465 19.3103 18.955 19.5258 18.792 19.6847C18.6291 19.8435 18.4081 19.9328 18.1777 19.9328H4.85519C4.62674 19.9328 4.40748 19.8451 4.24487 19.6887C4.08226 19.5322 3.98937 19.3197 3.98633 19.0969V15.7084C3.98815 15.4996 4.06853 15.2986 4.21223 15.1437C5.14298 14.1605 6.27247 13.3758 7.52956 12.8391C8.78665 12.3025 10.1441 12.0254 11.5164 12.0254C12.8887 12.0254 14.2462 12.3025 15.5033 12.8391Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 10.8967C13.7549 10.8967 15.5703 9.12681 15.5703 6.94349C15.5703 4.76017 13.7549 2.99023 11.5156 2.99023C9.27627 2.99023 7.46094 4.76017 7.46094 6.94349C7.46094 9.12681 9.27627 10.8967 11.5156 10.8967Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCliente);
export default __webpack_public_path__ + "static/media/IconCliente.7f6c17ff05b7c76cc11cf505e40cb264.svg";
export { ForwardRef as ReactComponent };